/* eslint-disable no-lone-blocks */
import { useEffect, useRef, useState } from "react";
import {
  Card,
  Grid,
  FormLabel,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Chip,
  Typography,
} from "@mui/material";
import ErrorMessageComponent from "components/FormikErrorMessage";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import { useFormik } from "formik";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import FileUploadUI from "components/SuiFileUploadInput/FileUploadUI";
import AccountTypeDropdown from "components/SuiDropDownList/AccountTypeDropdown";
import {
  useGetTemplateInfoMutation,
  useGetPlanInfoMutation,
  useGetReferenceParametersInfoMutation,
  useCreateTemplateMutation,
  useTemplateGetByIdMutation,
  useUpdateTemplateMutation,
  useGetAllPlanInfoMutation,
  useGetTemplateServicesMutation,
  useGetTemplateSubServicesMutation,
  useGenerateFromWebsiteMutation,
  useGetAllTimezoneMutation
} from "app/features/api/AuthApi";
import useSuiSnackbar from "hooks/useSuiSnackbar";
import CommonSpinner from "components/CommonSpinner";
import colors from "assets/theme/base/colors";
import WrapCard from "Container/Cards/WrapCard";
import RowOrderingGrid from "./TemplateFormTable";
import {
  createTemplateValidation,
  createTenantTemplateValidation,
} from "Validation";
import TenantChatBot from "./TenantChatBot";
import { answersData, answersDataWithCalender } from "./answer";
import { useSelector } from "react-redux";
import SuiTypography from "components/SuiTypography";
import NumberInput from "components/SuiInput/NumberInput";
import SuiDropDownList from "components/SuiDropDownList";
import MultiSelectDropdown from "components/SuiDropDownList/MultiSelectDropdown";
import SuiTimeRangePicker from "components/SuiTimeRangePicker";
import SubServiceDropdown from "./components";
import SuiRadioGroup from "components/SuiRadioGroup";
import CustomEndPoints, { CustomEndpointsV2 } from "./components/CustomEndPoints";
import { PREDEFINED_CUSTOM_ENDPOINTS, SERVICE_AREAS, WEEK_DAYS  } from "./constants";

const DEFAULT_OPERATING_HRS = "09:00 AM - 05:00 PM";

const ARRAY_FIELDS = ["teamMembers", "faqs"];

const DEFAULT_KNOWLEDGE_BASE = {
  consultationPolicy: {
    question: "Do you accept walk-ins, appointments, or both?",
    answer: ""
  },
  consultationProcess: {
    question: "Describe your consultation, service, or onboarding process",
    answer: ""
  },
  officeLocations: {
    question: "Where is your office located? If you have multiple locations, please list them with details.",
    answer: ""
  },
  teamMembers: {
    question: "Please list key team members and their roles.",
    answer: [
      { name: "", role: "" }
    ]
  },
  servicesOffered: {
    question: "What services or products do you offer?",
    answer: ""
  },
  excludedServices: {
    question: "Are there services you do NOT offer that the chatbot should filter out?",
    answer: ""
  },
  serviceAreas: {
    question: "What geographic areas do you serve?",
    answer: ""
  },
  billingProcess: {
    question: "Briefly describe your pricing or payment structure.",
    answer: ""
  },
  paymentPlans: {
    question: "Do you offer payment plans or financing?",
    answer: ""
  },
  faqs: {
    question: "What are the most common questions your clients ask?",
    answer: [
      { question: "", answer: "" }
    ]
  },
  leadCollectionFocus: {
    question: "What types of service should the chatbot prioritize or collect information for?",
    answer: ""
  },
  leadFields: {
    question: "For each type of inquiry, what information would you like the chatbot to collect?",
    answer: ""
  }
};

const CreateTenant = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams()
  const navigate = useNavigate();
  const { permission } = useSelector((state) => state.auth);
  const suiSnackbar = useSuiSnackbar();

  const customEndpointRef = useRef(null)

  const [createTemplate, { isLoading: createLoader }] =
    useCreateTemplateMutation();
    const [templateGetById, { isLoading: loader }] = useTemplateGetByIdMutation();
    const [updateTemplate, { isLoading: updateLoader }] =
      useUpdateTemplateMutation();
    const [getTemplateInfo] = useGetTemplateInfoMutation();
    const [getReferenceParametersInfo] = useGetReferenceParametersInfoMutation();
    const [getTemplateSubServices] = useGetTemplateSubServicesMutation();
    const [generateFormWebsite]= useGenerateFromWebsiteMutation();
    const [getAllTimezone] = useGetAllTimezoneMutation()

  const [mobileInValid, setMobileInValid] = useState(false);
  const [step, setStep] = useState("first");
  const [templateData, setTemplateData] = useState([]);
  const [isMergedFalg, setIsMergedFalg] = useState(false);
  const [referencePara, setReferencePara] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [subServices, setSubServices] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [plans, setPlans] = useState([]);
  const [serviceArr, setServiceArr] = useState([]);
  const [templateServices, setTemplateServices] = useState([]);
  const [templateDataById, setTemplateDataById] = useState([]);
  const [planType, setPlanType] = useState(null);
  const [subServiceArr, setSubServiceArr] = useState([]);
  const [answerArray, setAnswerArray] = useState(answersData);
  const [templateDataForROws, setTemplateDataForROws] = useState([]);
  const [hyperLinkdata, setHyperLinkdata] = useState([]);
  const [leadFormData, setLeadFormData] = useState([]);
  const [leadCollectionData, setLeadCollectionData] = useState("");
  const [subserviceList, setSubserviceList] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [customEndpoints, setCustomEndpoints] = useState(PREDEFINED_CUSTOM_ENDPOINTS);
  const [toBeDeleteFiles, setToBeDeleteFiles] = useState([]); // knowledge based files to delete while update
  const [isGeneratingFromWebsite, setIsGeneratingFromWebsite] = useState(false);
  const [knowledgeBaseData, setKnowledgeBaseData] = useState(
  DEFAULT_KNOWLEDGE_BASE
);

  const templateFormat = searchParams.get('templateFormat')
  const loginType = localStorage.getItem("type");
  const subscriptionType = localStorage.getItem("subscriptionType");
  const type = localStorage.getItem("type");
  const isEditing = Boolean(id);

  const handleKBArrayChange = (key, index, field, value) => {
    setKnowledgeBaseData(prev => {
      const updated = [...(prev[key].answer || [])];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        [key]: {
          ...prev[key],
          answer: updated,
        },
      };
    });
  };

  const addKBArrayItem = (key) => {
    const newItem =
      key === "teamMembers"
        ? { name: "", role: "" }
        : { question: "", answer: "" };

    setKnowledgeBaseData(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        answer: [...(prev[key].answer || []), newItem],
      },
    }));
  };

  const normalizeKnowledgeBase = (rawKB, defaultKB) => {
    const normalized = { ...defaultKB };

    Object.entries(defaultKB).forEach(([key, defValue]) => {
      const incoming = rawKB?.[key];

      if (incoming === null || incoming === undefined) {
        normalized[key] = defValue;
        return;
      }

      if (ARRAY_FIELDS.includes(key)) {
        let answerArray = Array.isArray(incoming) ? incoming : defValue.answer;
        
        if (answerArray.length === 0) {
          answerArray = defValue.answer;
        }

        normalized[key] = {
          ...defValue,
          answer: answerArray,
        };
        return;
      }

      normalized[key] = {
        ...defValue,
        answer: typeof incoming === "string" ? incoming : defValue.answer,
      };
    });

    return normalized;
  };
  const applyServicesFromAI = (selectedServices = []) => {
    if (!Array.isArray(selectedServices)) return;

    const serviceIds = selectedServices
      .map(s => s?.id)
      .filter(Boolean);

    if (!serviceIds.length) return;

    handleServiceChange(serviceIds);
  };

  const applyVariableForm = (variableForm) => {
    if (!variableForm) return;

    const generatedEndpoints = Object.entries(variableForm).map(
      ([key, val]) => ({
        label: val.label,
        lookupKey: key,
        description: val.description,
        required: false
      })
    );

    setCustomEndpoints(prev => [
      ...PREDEFINED_CUSTOM_ENDPOINTS,
      ...generatedEndpoints
    ]);
  };

  const normalizePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
      return '';
    }

    const digits = phoneNumber.replace(/\D/g, '');
    return digits;
  };

  const handleGenerateFromWebsite = async () => {
    const website = formik.values.businessWebsite;

    if (!website) {
      suiSnackbar("Please enter a business website first", "error");
      return;
    }

    try {
      setIsGeneratingFromWebsite(true);

      const response = await generateFormWebsite({ website }).unwrap();

      console.log("AUTO-GENERATED CONFIG:", response);

      const { businessForm, variableForm, knowledgeBase } = response.data;

      if (knowledgeBase) {
        setKnowledgeBaseData(prev =>
          normalizeKnowledgeBase(
            knowledgeBase,
            prev
          )
        );
      }

      applyBusinessFormToFormik(businessForm);
      applyVariableForm(variableForm);

      suiSnackbar("Website analyzed successfully!", "success");
    } catch (err) {
      console.error("Generate from website failed:", err);
      suiSnackbar("Failed to generate from website", "error");
    } finally {
      setIsGeneratingFromWebsite(false);
    }
  };

  const setIfPresent = (field, value) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      formik.setFieldValue(field, value);
    }
  };

  const sanitizeName = (value) => {
    return value.replace(/[^a-zA-Z0-9 -]/g, "");
  };

  const applyBusinessFormToFormik = (businessForm) => {
    if (!businessForm) return;

    setIfPresent("businessName", sanitizeName(businessForm.businessName));
    setIfPresent("chatbotName", businessForm.businessName);
    setIfPresent("name", sanitizeName(businessForm.businessName));

    setIfPresent("businessAddress", businessForm.businessAddress);
    setIfPresent("businessEmail", businessForm.businessEmail);

    if (businessForm.businessPhoneNumber) {
      setIfPresent(
        "businessPhoneNumber",
        normalizePhoneNumber(businessForm.businessPhoneNumber)
      );
    }

    if (businessForm.businessType) {
      handleBusinessType({ target: { value: businessForm.businessType } });

      setTimeout(() => {
        applyServicesFromAI(businessForm.selectedServices);
      }, 300);
    }

    setIfPresent("freeEstimates", businessForm.freeEstimates);
    setIfPresent("serviceArea", businessForm.serviceArea);

    setIfPresent(
      "selectTime",
      businessForm.selectTime || DEFAULT_OPERATING_HRS
    );

    setIfPresent("timeZone", businessForm.timeZone);

    try {
      if (businessForm.selectDay) {
        const days = JSON.parse(businessForm.selectDay);
        if (Array.isArray(days) && days.length > 0) {
          formik.setFieldValue("selectDay", days);
          setSelectedDays(days);
        }
      }
    } catch (e) {
      console.warn("Failed to parse selectDay");
    }
  };

  async function fetchTemplateSubServices(serviceIds = []) {
    try {
      const { statusCode, data } = await getTemplateSubServices({
        serviceIds: serviceIds,
      }).unwrap();

      if (statusCode !== 200) return;

      const { subservices } = data;

      return subservices;
    } catch (error) {
      console.error(error);
    }
  }

  async function handleServiceChange(selectedValues) {
    formik.setFieldValue("service", selectedValues);

    try {
      if (selectedValues.length === 0) {
        setSubserviceList([]);
        setSubServices([]);
        formik.setFieldValue("sub_services", []);
        return;
      }

      const subServices = await fetchTemplateSubServices(selectedValues);

      const list = subServices.map(({ id, name, subServiceId }) => ({
        id,
        label: name,
        parentServiceId: subServiceId,
      }));

      setSubserviceList(list);
      setSubServices(list);

      formik.setFieldValue(
        "sub_services",
        list.map(({ id }) => id)
      );
    } catch (error) {
      console.error(error);
    }
  }

  function handleSubServiceChange(sub_services) {
    const subServiceIds = sub_services.map(({ id }) => id);
    formik.setFieldValue("sub_services", subServiceIds  );

    setSubServices(sub_services);
  }

  function handleSelectDayChange(days) {
    formik.setFieldValue("selectDay", days);

    const filteredDays = WEEK_DAYS
      .filter(({ id }) => days.includes(id))
      .map(({ id }) => id);

    setSelectedDays(filteredDays);
  }

  function handleSelectTime(time) {
    formik.setFieldValue("selectTime", time);
  }

  const onClickCancel = () => {
    navigate(-1) // hack 2 navigate to last screen based on tenant/admin type
  };

  useEffect(() => {
    if (
      permission &&
      loginType === "admin" &&
      !permission?.includes("chatbot:create")
    ) {
      navigate("/profile");
    }
  }, [permission]);

  
  const initialValues = {
    name: id ? templateDataById?.cb_Template?.templateName : "",
    data: id ? templateDataForROws : [],
    xcally: id ? templateDataById?.xcally ?? false : false,
    variantKey: id ? templateDataById?.variantKey ?? "" : "",
    chatbotName: id ? templateDataById?.cb_Template?.chatbotName ?? "" : "",
    chatbotWelcomeMessage: id ? templateDataById?.cb_Template?.chatbotWelcomeMessage ?? "" : "Hello ! Welcome, How may I help you?",
    businessName: id ? templateDataById?.businessName ?? "" : "",
    businessAddress: id ? templateDataById?.businessAddress ?? "" : "",
    businessEmail: id ? templateDataById?.businessEmail ?? "" : "",
    businessWebsite: id ? templateDataById?.businessWebsite ?? "" : "",
    businessPhoneNumber: id ? templateDataById?.businessPhoneNumber ?? "" : "",
    businessType: id
      ? templateDataById?.businessType === "Legal Services"
        ? "legal_service"
        : "home_service"
      : "legal_service",
    service: [],
    sub_services: [],
    freeEstimates: id ? templateDataById?.freeEstimates ?? "" : "",
    subscriptionPlanId: id ? templateDataById?.cb_Template?.subscriptionPlanId ?? "" : "",
    // subscriptionPlanId: id ? (templateDataById?.cb_template?.subscriptionPlanId != 'undefined') ? templateDataById?.cb_template?.subscriptionPlanId : "" ?? "" : "",
    selectDay: id
      ? templateDataById?.selectDay
        ? templateDataById?.selectDay
        : []
      : [],
    selectTime: id ? templateDataById?.selectTime ?? DEFAULT_OPERATING_HRS : DEFAULT_OPERATING_HRS,
    timeZone: id ? templateDataById?.timeZone ?? "" : "",
    // selectTime: id ? templateDataById?.selectTime ?? DEFAULT_OPERATING_HRS : (!templateDataById?.is247Services ? DEFAULT_OPERATING_HRS : ""), //TODO: to refactor
    is247Services: id ? templateDataById?.is247Services : false,
    knowledgebaseFiles: id ? templateDataById?.cb_TemplateKnowledgeFiles : "",
    serviceArea: id ? templateDataById?.serviceArea ?? "" : "",
    templateAiType: "fully",
    isChatTranscript: id ? templateDataById?.isChatTranscript ?? false : false,
    deleteFiles: [],
    otherServices: 
      id 
      ? templateDataById?.otherServices?.map(({ name }) => name) ?? [] 
      : []
  };
  const handleDeleteSubService = (serviceId) => {
    const filteredSubServices = subServices.filter(
      ({ id }) => id !== serviceId
    );
    const filteredSubServiceIds = filteredSubServices.map(({ id }) => id);

    setSubServices(filteredSubServices);
    formik.setFieldValue("sub_services", filteredSubServiceIds);

    // handle other service: other service have name as their id unlike sub service
    if(typeof serviceId === 'string'){
      const filteredOtherServices = formik.values.otherServices.filter(service => service !== serviceId);
      formik.setFieldValue("otherServices", filteredOtherServices);
    }
  };

  const handleAddNewSubService = service => {
    // Generate a unique ID
    const newServiceWithId = { 
      id: `user-defined--${service.label}`, 
      label: service.label, 
      parentServiceId: null
    };

    // Update subserviceList state
    setSubserviceList((prevList) => {
      const updatedList = [...prevList, service];
      return updatedList;
    });

    // Update subServices state
    setSubServices((prevServices) => {
      const updatedServices = [...prevServices, newServiceWithId];
      return updatedServices;
    });

    // Optional: Update Formik values if needed
    formik.setFieldValue('otherServices', [
      ...formik.values.otherServices, 
      service.label
    ]);
  }

  const handleDeleteDay = (day) => {
    setSelectedDays(selectedDays.filter((i) => i !== day));
    formik.setFieldValue(
      "selectDay",
      selectedDays.filter((i) => i !== day)
    );
  };
  const validateParamValue = (rows) => {
    let isValid = true;
    const updatedRows = [...rows];

    const queJumpToHit = rows?.map((row, index) => row.questionId);
    updatedRows.forEach((row, index) => {
      if (
        type === "tenant" &&
        row.answerType === "Calender" &&
        !row.calendlyIntegrationId
      ) {
        formik.setFieldError(
          `data.${index}.answerType`,
          "Kindly select calendar"
        );
        suiSnackbar("Kindly select calendar", "error");
        isValid = false;
      }
    });

    updatedRows.forEach((row, index) => {
      if (
        row.answerType === "Selectable_Option" ||
        row.answerType === "Searchable_Dropdown"
      ) {
        if (!row.paramValue || row.paramValue.length === 0) {
          formik.setFieldError(
            `data.${index}.answerType`,
            "Please fill the value in the dialog box"
          );
          isValid = false;
        }
        if (row.paramValue) {
          const paramvalueQueToHit = row.paramValue.map(
            (val) => val.questionToHit
          );
          paramvalueQueToHit.forEach((val) => {
            if (val && !queJumpToHit?.includes(parseInt(val))) {
              formik.setFieldError(
                `data.${index}.answerType`,
                "Jump to value exceeds the number of questions."
              );
              isValid = false;
            }
          });
        }
      }
    });
    return isValid;
  };
  const [getAllPlanInfo] = useGetAllPlanInfoMutation();
  const [getTemplateServices] = useGetTemplateServicesMutation();
  // const [getTemplateSubServices] = useGetTemplateSubServicesMutation();
  const tenantSubscriptionPlan = localStorage.getItem("subscriptionType");
  const tenantSubscriptionType = tenantSubscriptionPlan?.split(", ");

  const handleSelectDays = (e) => {
    const val = e.target.value;
    const checkAlreadyAdded =
      selectedDays?.filter((item) => item === val) || [];

    if (checkAlreadyAdded?.length === 0) {
      setSelectedDays([...selectedDays, val]);
      formik.setFieldValue("selectDay", [...selectedDays, val]);
    }
  };

  let leadCollectionFormData = {};

  const fetchTenantById = async () => {
    try {
      const response = await templateGetById(id).unwrap();
      
      const clonedData = JSON.parse(JSON.stringify(response?.data));

      // Sort the cloned cb_Questions
      clonedData.cb_Questions?.sort((a, b) => a.questionId - b.questionId);

      const transformedResponse = clonedData?.cb_Questions?.map(
        (item, index) => {
          if (item?.answerType === "Lead_Collection_Form") {
            leadCollectionFormData = {
              ...leadCollectionFormData,
              [index]: {
                title: item?.formTitle,
                data: item?.subQuestions,
              },
            };
          }
          return {
            id: item.id,
            isPushed: item.isPushed,
            questionId: item.questionId,
            questionName: item.questionName || "",
            answerType: item.answerType || "",
            referenceParameterId: item.referenceParameterId,
            cb_ReferenceParameter: item.cb_ReferenceParameter,
            name:
              item.cb_ReferenceParameter &&
              item.cb_ReferenceParameter.type === "custom"
                ? item.cb_ReferenceParameter.name
                : "",
            paramValue:
              item.cb_Answers.length > 0 ? item.cb_Answers[0].paramValue : [],
            questionToHit: item.questionToHit || "",
            calendlyIntegrationId: item?.calendlyIntegrationId,
            chatbotName: item.chatbotName,
            hyperLink:
              item.cb_Answers.length > 0 ? item.cb_Answers[0].hyperLink : [],
          };
        }
      );
      if (clonedData?.cb_Questions) {
        const formedResponse = clonedData?.cb_Questions
          ?.map((item, id) => {
            if (item?.subQuestions) {
              return item?.subQuestions.map((res, index) => {
                return {
                  currentRowIndex: id,
                  currId: res.id,
                  ldParamValue: res?.cb_Answers[0]?.paramValue,
                };
              });
            }
          })
          .filter((res) => res)
          .flat();

        setLeadFormData(formedResponse);
      }

      const { data  = {}} = response;

      // set up custom endpoints data

      const { cb_Template = {} } = data;
      const { cb_CustomParameters } = cb_Template;

      setCustomEndpoints(cb_CustomParameters)

      setTemplateDataById(data);
      // hydrate KB on edit
      if (data.cb_Template.cb_TemplateKnowledgeBase) {
        setKnowledgeBaseData(
          normalizeKnowledgeBase(
            data.cb_Template.cb_TemplateKnowledgeBase,
            DEFAULT_KNOWLEDGE_BASE
          )
        );
      }
      setLeadCollectionData(leadCollectionFormData);

      setUpDefaultService(data);
      setTemplateDataForROws(transformedResponse);
    } catch (err) {
      console.log(err);
    }
  };

  async function setUpDefaultService(defaultTemplateState) {
    const { businessType, selectedServices, otherServices } = defaultTemplateState;

    const BUSINESS_TYPE_MAP = {
      "Home Services": 1,
      "Legal Services": 2,
    };

    const selectedBusinessType = BUSINESS_TYPE_MAP[businessType];

    if (!selectedServices) {
      await getTemplateServicesData(selectedBusinessType);
      return;
    }

    const serviceIds = selectedServices.map(({ id }) => id);
    const subServiceIds = selectedServices.flatMap(
      ({ subServices }) => subServices
    );

    const [_, subServiceList] = await Promise.all([
      getTemplateServicesData(selectedBusinessType),
      fetchTemplateSubServices(serviceIds),
    ]);

    const fullSubServiceList = subServiceList
    .map(({ id, name, subServiceId }) => ({
      id,
      label: name,
      parentServiceId: subServiceId,
    }));

    // selected options
    const list = subServiceList
      .filter(({ id }) => subServiceIds.includes(id))
      .map(({ id, name, subServiceId }) => ({
        id,
        label: name,
        parentServiceId: subServiceId,
      }));

    if(Boolean(otherServices.length)){
      const customServices = otherServices.map(({ name }) => ({ id: name, label: name, parentServiceId: null }))
      list.push(...customServices);
      fullSubServiceList.push(...customServices);
    }

    setSubserviceList(fullSubServiceList); // full dropdown list
    setSubServices(list); // selected opts

    formik.setFieldValue("service", serviceIds);
    formik.setFieldValue("sub_services", subServiceIds);
  }

  const getPlans = async () => {
    try {
      const response = await getAllPlanInfo();
      const res = response?.data?.data?.map((item) => {
        let typeArray =
          item.type === "xcally, calendly"
            ? item.type.split(", ").map((type) => type.trim())
            : [item.type];
        return { id: item?.id, label: item?.subscriptionName, type: typeArray };
      });
      setPlans(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTimezoneList = async () => {
    try {
      const response = await getAllTimezone().unwrap();

      const { data, statusCode } = response;

      if(statusCode !== 200) return;
      
      setTimeZoneList(data)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchTemplate = async () => {
    try {
      const response = await getTemplateInfo().unwrap();
      if (response.statusCode === 200) {
        {
          response?.data?.templates?.map((item) => {
            if (item.isMergeTemplate) {
              setIsMergedFalg(true);
            }
          });
        }

        setTemplateData(response?.data?.templates);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReferenceParameter = async () => {
    try {
      const response = await getReferenceParametersInfo().unwrap();
      if (response.statusCode === 200) {
        setReferencePara(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // fetchTemplate();
    fetchReferenceParameter();
    getPlans();
    fetchTimezoneList()
    if (id) {
      fetchTenantById();
      // template service will be fetched wrt selected businessType else default Legal services
    } else {
      getTemplateServicesData();
    }
  }, []);

  const removeEmptyQuestionToHit = (data) => {
    return data.map((item) => {
      const {
        questionToHit,
        referenceParameterId,
        calendlyIntegrationId,
        ...rest
      } = item;

      if (questionToHit === "" && referenceParameterId === "") {
        return rest;
      }

      const newItem = { ...item };
      if (!calendlyIntegrationId) {
        delete newItem.calendlyIntegrationId;
      }

      if (item?.answerType !== "Calender" && calendlyIntegrationId) {
        delete newItem.calendlyIntegrationId;
      }
      if (questionToHit === "" || questionToHit === null) {
        delete newItem.questionToHit;
      }
      return newItem;
    });
  };

  const handleBusinessType = (e) => {
    const val = e.target.value;

    const BUSINESS_TYPE_MAP = {
      home_service: 1,
      legal_service: 2,
    };

    formik.setFieldValue("businessType", val);
    formik.setFieldValue("sub_services", []);
    formik.setFieldValue("service", []);
    setSubServices([]);

    const selectedBusiness = BUSINESS_TYPE_MAP[val];

    getTemplateServicesData(selectedBusiness);
  };

  const mainLeadCollectionHandler = (data, currentRowIndex) => {
    setLeadCollectionData({
      ...leadCollectionData,
      [currentRowIndex]: data,
    });
  };
  const updateLeadCollectionData = (index) => {
    let tempData = leadCollectionData;
    delete tempData[index?.toString()];
    setLeadCollectionData(tempData);
  };

  const updateLeadCollectionDataOnDragandDrop = (index, dragIndex) => {
    let tempData = leadCollectionData;
    if (tempData.hasOwnProperty(dragIndex)) {
      tempData[index] = tempData[dragIndex];
    }
    delete tempData[dragIndex];

    const newData = leadFormData?.map((data) => {
      if (data?.currentRowIndex === dragIndex) {
        return {
          ...data,
          currentRowIndex: index,
        };
      }
    });
    setLeadFormData(newData);
    setLeadCollectionData(tempData);
  };

  const handleIs247ServiceChange = (event) => {
    formik.setFieldValue("is247Services", event.target.checked);
    if (event.target.checked) {
      setSelectedDays([]);
      formik.setFieldValue("selectDay", []);
      formik.setFieldValue("selectTime", "");
    }
  };

  const validateData = (data) => {
    let tempData = [];
    const leadCollectionCheck = data?.filter((data, index) => {
      if (data?.answerType === "Lead_Collection_Form") {
        tempData?.push({
          index: index,
          data: data,
        });
      }
    });

    if (tempData?.length > 1) {
      suiSnackbar("Only one Lead Collection Form allowed.", "error");
      return false;
    } else if (tempData?.length > 0 && tempData?.[0]?.index !== 0) {
      suiSnackbar("Lead Collection Form allow only at the top.", "error");
      return false;
    } else {
      return true;
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema:
      type === "tenant"
        ? createTenantTemplateValidation
        : createTemplateValidation,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const isValidCustomEndpoints = customEndpointRef.current.isValidInputs();

      if(!isValidCustomEndpoints) return;
      
      const deleteId = values.questionsToDelete ? values.questionsToDelete : [];
      let processedData;
      
      values.data?.map((item, id) => {
        if (
          item.answerType === "Selectable_Option" ||
          item.answerType === "Searchable_Dropdown"
        ) {
          item.questionToHit = null;
        }

        if (leadCollectionData) {
          item.data = leadCollectionData[id]?.data.map((x, i) => {
            return {
              questionName: x.questionName,
              answerType: x.answerType,
              isPushed: x.isPushed,
              referenceParameterId: x.referenceParameterId,
              name: x?.name,
              id: x?.id,
              formTitle: leadCollectionData[0]?.title,
            };
          });

          item.formTitle = leadCollectionData[id]?.title || "";
        }

        let hyperLink = hyperLinkdata.find((item) => item.id === id);

        if (hyperLink) {
          item.hyperLink = hyperLinkdata.find(
            (item) => item.id === id
          )?.hyperlink;
        }
        if (leadFormData.length > 0) {
          const isData = leadFormData.filter(
            (item) => item.currentRowIndex === id
          );

          if (isData.length > 0) {
            isData?.forEach((res) => {
              const dataItem = item?.data?.find((d) => d.id === res.currId);
              if (dataItem) {
                dataItem.paramValue = res.ldParamValue;
              }
            });
          }
        }
      });

      // TODO: temp comment, not sure what this block does
      // if (id) {
      //   const cleanedData = values.data.map((item) => {
      //     const { cb_Answers, cb_ReferenceParameter, ...rest } = item;
      //     return rest;
      //   });
      //   processedData = removeEmptyQuestionToHit(cleanedData);
      // } else {
      //   processedData = removeEmptyQuestionToHit(values.data);
      // }

      // if (values) {
      delete values.variantKey;
      delete values.xcally;
      // }
      // if (planType?.includes('xcally') && !values.variantKey) {
      //   delete values.variantKey;
      // }

      try {
        const formData = new FormData();
        formData.append("chatbotName", values.chatbotName);
        formData.append("chatbotWelcomeMessage", values.chatbotWelcomeMessage);
        formData.append("templateName", values.name);
        formData.append("businessEmail", values.businessEmail);
        
        // if not passing then getting error in api for business form
        // if (type !== "tenant") {
          formData.append("subscriptionPlanId", values.subscriptionPlanId);
        // }
        formData.append("businessName", values.businessName);
        formData.append("businessWebsite", values.businessWebsite);
        formData.append("businessPhoneNumber", values.businessPhoneNumber);
        formData.append("businessAddress", values.businessAddress);
        formData.append(
          "businessType",
          values.businessType === "legal_service"
            ? "Legal Services"
            : "Home Services"
        );
        formData.append("freeEstimates", values.freeEstimates);
        formData.append("is247Services", values.is247Services);
        formData.append("selectDay", [JSON.stringify(values.selectDay)]);
        formData.append("selectTime", values.selectTime);
        formData.append("timeZone", values.timeZone);
        formData.append("serviceArea", values.serviceArea);

        const selectedServicesArray = values.sub_services.reduce(
          (acc, subServiceId) => {
            const subService = subserviceList.find(
              (item) => item.id === subServiceId
            );

            if (!subService) return acc;

            const parentServiceId = subService.parentServiceId;

            const existingService = acc.find(
              (service) => service.id === parentServiceId
            );

            if (existingService) {
              existingService.subServices.push(subService.id);
            } else {
              acc.push({
                id: parentServiceId,
                subServices: [subService.id],
              });
            }

            return acc;
          },
          []
        )
        .filter(({ id }) => Boolean(id));//filter out the user created sub service obj      

        formData.append(
          "selectedServices",
          JSON.stringify(selectedServicesArray)
        );
        formData.append('otherServices', JSON.stringify(values.otherServices))

        if (
          values.knowledgebaseFiles &&
          Array.isArray(values.knowledgebaseFiles)
        ) {
          values.knowledgebaseFiles.forEach((file) => {
            formData.append("knowledgebaseFiles", file);
          });
        }

        formData.append("templateAiType", values.templateAiType);

        // TODO: return boolean from get api
        const transformedEndpoints = customEndpoints
          .filter(endpoint => endpoint.label && endpoint.lookupKey && endpoint.description)
          .map(endpoint => ({
            ...endpoint,
            required: endpoint.required === "true",
          }));

        formData.append("customEndpoints", JSON.stringify(transformedEndpoints));
        formData.append("isChatTranscript", values.isChatTranscript)

         const serializedKnowledgeBase = Object.entries(knowledgeBaseData).reduce(
            (acc, [key, value]) => {
              acc[key] = value.answer;
              return acc;
            },
            {}
          );

          formData.append(
            "knowledgeBase",
            JSON.stringify(serializedKnowledgeBase)
          );
        
        if(Boolean(toBeDeleteFiles.length)){
          formData.append("deleteFile", JSON.stringify(toBeDeleteFiles))
        }

        formData.append("templateFormat", templateFormat)

        // if (validateParamValue(values.data) && validateData(values.data)) {
        const response = id
          ? await updateTemplate({
              data: formData,
              id,
            }).unwrap()
          : await createTemplate(formData).unwrap();

          if (response.statusCode === 200) {
          suiSnackbar(response.message, "success");

          navigate(-1) // hack 2 navigate to last screen based on tenant/admin type
          }
        // }
      } catch (err) {
        console.error(err);
      }
    },
  });

  const isOperatingDayHrsDisabled = formik.values.is247Services;

  useEffect(() => {
    if (templateDataById) {
      const getServiceIds = templateDataById?.selectedServices?.map(
        (item) => item.id
      );
      formik.setFieldValue("services", getServiceIds);
      setServices(getServiceIds);
      const subServicesIds = [];
      templateDataById?.selectedServices?.forEach((item) => {
        item.subServices?.forEach((i) => {
          subServicesIds.push({ service_id: item.id, value: i });
        });
      });
      setSelectedDays(templateDataById?.selectDay || []);
      setSubServices(subServicesIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateDataById]);

  const getTemplateServicesData = async (selectedBusiness = 2) => {
    try {
      const response = await getTemplateServices({
        serviceId: selectedBusiness,
      });
      const res = response?.data?.data?.subServices?.map((item) => {
        return { id: item?.id, label: item?.name };
      });
      setServiceArr(res);
    } catch (err) {
      console.log(err);
    }
  };

  // const handleFileChange = (files) => {
  //   if (Array.isArray(files)) {
  //     formik.setFieldValue("knowledgebaseFiles", files);
  //   } else if (files) {
  //     formik.setFieldValue("knowledgebaseFiles", [files]);
  //   } else {
  //     formik.setFieldValue("knowledgebaseFiles", null);
  //   }
  // };

  const handleFileChange = (files) => {
    const existingFiles = formik.values.knowledgebaseFiles || [];

    if (Array.isArray(files)) {
      // Check if any file already exists
      const newFiles = files.filter(
        (file) =>
          !existingFiles.some((f) => f.name === file.name) || //the uploaded actual files
          !existingFiles.some((f) => f.fileName === file.name) // files fetched from server
      );

      if (newFiles.length === 0) return;

      formik.setFieldValue("knowledgebaseFiles", [
        ...existingFiles,
        ...newFiles,
      ]);
    } else if (files) {
      // Check for single file duplicate
      if (existingFiles.some((f) => f.name === files.name)) return;

      formik.setFieldValue("knowledgebaseFiles", [...existingFiles, files]);
    } else {
      formik.setFieldValue("knowledgebaseFiles", null);
    }
  };

  const removeFileName = (selectedFile) => {
    const uploadedFiles = formik.values.knowledgebaseFiles;
    const filteredFiles = uploadedFiles.filter((file) => {
      if (file instanceof File) {
        return file.name !== selectedFile;
      }

      return file.fileName !== selectedFile;
    });

    formik.setFieldValue("knowledgebaseFiles", filteredFiles);

    if(!isEditing) return;

    if(!toBeDeleteFiles.includes(selectedFile)) {
      const filterTheDeletedFile = uploadedFiles.filter(file => 
        file.name == selectedFile || file.fileName == selectedFile
      )
     
      setToBeDeleteFiles(prev => [...prev, ...filterTheDeletedFile])
    }
  };

  useEffect(() => {
    if (formik.values.subscriptionPlanId) {
      const planId = formik.values.subscriptionPlanId;
      const plan = plans.filter((item) => item.id === planId);

      if (plan.length > 0) {
        const planType = plan[0].type;
        setPlanType(planType);
        let updatedAnswers = [...answersData];
        if (planType.includes("calendly")) {
          setAnswerArray(answersDataWithCalender);
        } else {
          setAnswerArray(answersData);
          updatedAnswers = updatedAnswers.filter(
            (item) => item.value !== "Calender"
          );
        }
      }
    }
    if (tenantSubscriptionType.includes("calendly"))
      setAnswerArray(answersDataWithCalender);
  }, [formik.values.subscriptionPlanId, plans]);

  const [value, setValue] = useState("female");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const genderOptions = [
    { value: "female", label: "Female" },
    { value: "male", label: "Male" },
    { value: "other", label: "Other" },
    { value: "prefer-not-to-say", label: "Prefer not to say", disabled: true },
  ];

  function scrollToFirstFormikError() {
    const errorElement = document.querySelector(".formik-error");

    if(!errorElement) return;

    errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  useEffect(() => {
    if (formik.isSubmitting && !formik.isValid) {
      scrollToFirstFormikError();
    }
  }, [formik.isSubmitting, formik.isValid])

  return (
    <div>
      {type === "tenant" && !id ? (
        <TenantChatBot />
      ) : (
        <WrapCard
          title={
            id ? "Update Template Configuration" : "Template Configuration"
          }
        >
          {loader ? (
            <CommonSpinner size="100px" color={colors.primary.main} />
          ) : (
            <>
              <Grid component="form" container spacing={2} rowSpacing={3}>
                {/* <Grid item xs={12} lg={6}>
                  <div>
                    <FormLabel htmlFor="name" required>
                      Template Name
                    </FormLabel>
                    <SuiInput
                      inputSettungs={{ autoComplete: "off", required: true }}
                      type="text"
                      placeholder="Enter Template Name"
                      id="name"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <ErrorMessageComponent
                      touched={formik.touched.name}
                      error={formik.errors.name}
                    />
                  </div>
                </Grid> */}
                {step === "first" && (
                  <>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        margin: "8px 0",
                        borderBottom: "4px solid #E4E9F0",
                        paddingBottom: "36px",
                      }}
                    >
                      <Grid item xs={12} lg={12} my={2}>
                        <Typography fontSize="14px" fontWeight="semiBold">
                          Chatbot Configuration
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="name" required>
                            Chatbot Name
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            type="text"
                            placeholder="Enter Chatbot Name"
                            id="name"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.name}
                            error={formik.errors.name}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="chatbotName" required>
                            Chat Template Name
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            type="text"
                            placeholder="Enter Chatbot Template Name"
                            id="chatbotName"
                            name="chatbotName"
                            value={formik.values.chatbotName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.chatbotName}
                            error={formik.errors.chatbotName}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="chatbotWelcomeMessage">
                            Chatbot Welcome Message
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off"
                            }}
                            type="text"
                            placeholder="Enter Welcome Message"
                            id="chatbotWelcomeMessage"
                            name="chatbotWelcomeMessage"
                            value={formik.values.chatbotWelcomeMessage}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.chatbotWelcomeMessage}
                            error={formik.errors.chatbotWelcomeMessage}
                          />
                        </div>
                      </Grid>
                      {type !== "tenant" && (
                        <Grid item xs={12} lg={6}>
                          <div>
                            <FormLabel htmlFor="subscriptionPlanId" required>
                              Subscription Plan
                            </FormLabel>
                            {/* <SuiTypography
                            variant="h6"
                            mt={1}
                            ml={3}
                            sx={{ color: "#999999 !important" }}
                          >
                            Fixed
                          </SuiTypography> */}
                            <AccountTypeDropdown
                              data={plans}
                              name="subscriptionPlanId"
                              value={formik.values.subscriptionPlanId}
                              setValue={formik.handleChange}
                              placeHolder="Select Subscription Plan"
                              onBlur={formik.handleBlur}
                              disabled={id ? true : false}
                            />
                            <ErrorMessageComponent
                              touched={formik.touched.subscriptionPlanId}
                              error={formik.errors.subscriptionPlanId}
                            />
                          </div>
                        </Grid>
                      )}
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        margin: "2px",
                        borderBottom: "4px solid #E4E9F0",
                        paddingBottom: "36px",
                      }}
                    >
                      <Grid item xs={12} lg={12} my={2}>
                        <Typography fontSize="14px" fontWeight="semiBold">
                          Business Information
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="businessName" required>
                            Business Name
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            type="text"
                            placeholder="Enter Business Name"
                            id="businessName"
                            name="businessName"
                            value={formik.values.businessName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.businessName}
                            error={formik.errors.businessName}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="businessWebsite" required>
                            Business Website
                          </FormLabel>
                            <SuiInput
                              inputSettungs={{
                                autoComplete: "off",
                                required: true,
                              }}
                              type="text"
                              placeholder="Enter Business Website"
                              id="businessWebsite"
                              name="businessWebsite"
                              value={formik.values.businessWebsite}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            <SuiButton
                              size="small"
                              variant="outlined"
                              buttonColor="info"
                              disabled={isGeneratingFromWebsite}
                              onClick={handleGenerateFromWebsite}
                              sx={{ whiteSpace: "nowrap", height: "40px", marginTop:"10px" }}
                            >
                              {isGeneratingFromWebsite ? (
                                <CircularProgress size="18px" />
                              ) : (
                                "Generate"
                              )}
                            </SuiButton>
                          <ErrorMessageComponent
                            touched={formik.touched.businessWebsite}
                            error={formik.errors.businessWebsite}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="businessAddress" required>
                            Business Address
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            type="text"
                            placeholder="Enter Business Address"
                            id="businessAddress"
                            name="businessAddress"
                            value={formik.values.businessAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.businessAddress}
                            error={formik.errors.businessAddress}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="businessEmail" required>
                            Business Email
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            type="text"
                            placeholder="Enter Business Email"
                            id="businessEmail"
                            name="businessEmail"
                            value={formik.values.businessEmail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.businessEmail}
                            error={formik.errors.businessEmail}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="businessPhoneNumber" required>
                            Business Phone Number
                          </FormLabel>
                          <SuiInput
                            inputSettungs={{
                              autoComplete: "off",
                              required: true,
                            }}
                            // type="number"
                            placeholder="Enter Business Phone Number"
                            id="businessPhoneNumber"
                            name="businessPhoneNumber"
                            value={formik.values.businessPhoneNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.businessPhoneNumber}
                            error={formik.errors.businessPhoneNumber}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}></Grid>
                      <Grid item xs={12} lg={12}>
                        <SuiRadioGroup
                          name="businessType"
                          valueKey="value"
                          required
                          labelKey="label"
                          label="Select Business Type"
                          row
                          options={[
                            { value: "home_service", label: "Home Services" },
                            { value: "legal_service", label: "Legal Services" },
                          ]}
                          value={formik.values.businessType}
                          onChange={handleBusinessType}
                          onBlur={formik.handleBlur}
                        />
                        <ErrorMessageComponent
                          touched={formik.touched.businessType}
                          error={formik.errors.businessType}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12}>
                        <div>
                          <MultiSelectDropdown
                            type="checkbox"
                            name="service"
                            onBlur={formik.handleBlur}
                            label="Services offered"
                            options={serviceArr}
                            value={formik.values.service}
                            onChange={handleServiceChange}
                            placeholder="Select services"
                            labelKey="label"
                            valueKey="id"
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.service}
                            error={formik.errors.service}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <div>
                          {/* <MultiSelectDropdown
                            type="default"
                            required
                            label="Sub Services"
                            name="sub_services"
                            onBlur={formik.handleBlur}
                            options={subserviceList}
                            value={formik.values.sub_services}
                            onChange={handleSubServiceChange}
                            placeholder="Select Sub Services"
                            labelKey="label"
                            valueKey="id"
                          /> */}
                          <SubServiceDropdown
                            options={subserviceList}
                            value={subServices}
                            onChange={handleSubServiceChange}
                            label="Sub Services"
                            placeholder="Select Sub Services"
                            onClickAddNewSubservice={handleAddNewSubService}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              display: "flex",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            {subServices?.map(({ id, label }) => (
                              <Chip
                                key={id}
                                label={label}
                                onDelete={() => handleDeleteSubService(id)}
                                color="primary"
                              />
                            ))}
                          </div>
                          <ErrorMessageComponent
                            touched={formik.touched.sub_services}
                            error={formik.errors.sub_services}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="subscriptionPlanId" required>
                            Do you offer free Estimates
                          </FormLabel>
                          <AccountTypeDropdown
                            data={[
                              { id: "Yes", label: "Yes" },
                              { id: "No", label: "No " },
                            ]}
                            name="freeEstimates"
                            value={formik.values.freeEstimates}
                            setValue={formik.handleChange}
                            placeHolder="Select"
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.freeEstimates}
                            error={formik.errors.freeEstimates}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <FormLabel htmlFor="serviceArea" required>
                          What is your Service Area
                        </FormLabel>
                        <SuiDropDownList
                          data={SERVICE_AREAS}
                          onBlur={formik.handleBlur}
                          select={{
                            key: "value",
                            valueKey: "value",
                            labelName: "name",
                            label: "Select service area",
                            name: "serviceArea",
                            val: formik.values.serviceArea,
                            fn: formik.handleChange,
                          }}
                        />
                        <ErrorMessageComponent
                          touched={formik.touched.serviceArea}
                          error={formik.errors.serviceArea}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      sx={{
                        margin: "2px",
                        borderBottom: "4px solid #E4E9F0",
                        paddingBottom: "36px",
                      }}
                    >
                      <Grid item xs={12} lg={12}>
                        <Typography fontSize="14px" fontWeight="semiBold">
                          <span style={{ color: "red" }}>*</span> What are your
                          Operating hours?
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <div style={{ maxWidth: '525px' }}>
                        <FormLabel htmlFor="timezone" required>
                          Timezone
                        </FormLabel>
                        <SuiDropDownList
                          data={timeZoneList}
                          onBlur={formik.handleBlur}
                          select={{
                            key: "id",
                            valueKey: "name",
                            labelName: "name",
                            label: "Select Timezone",
                            name: "timeZone",
                            val: formik.values.timeZone,
                            fn: formik.handleChange,
                          }}
                        />
                        <ErrorMessageComponent
                          touched={formik.touched.timeZone}
                          error={formik.errors.timeZone}
                        />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <MultiSelectDropdown
                            type="default"
                            label="Day"
                            disabled={isOperatingDayHrsDisabled}
                            options={WEEK_DAYS}
                            value={formik.values.selectDay}
                            onChange={handleSelectDayChange}
                            placeholder="Select Days"
                            labelKey="label"
                            valueKey="id"
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.selectDay}
                            error={formik.errors.selectDay}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              display: "flex",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            {selectedDays?.map((day, index) => (
                              <Chip
                                sx={{ marginTop: "5px" }}
                                key={day}
                                label={day}
                                onDelete={() => handleDeleteDay(day)}
                                color="primary"
                              />
                            ))}
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <div>
                          <FormLabel htmlFor="selectTime">
                            Operating Hours
                          </FormLabel>
                          <SuiTimeRangePicker
                            name="selectTime"
                            disabled={isOperatingDayHrsDisabled}
                            // value={formik.values.selectTime} TODO: to refactor
                            value={isOperatingDayHrsDisabled ? "" : formik.values.selectTime}
                            onChange={handleSelectTime}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.selectTime}
                            error={formik.errors.selectTime}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            paddingTop: "10px",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                              key={formik.values.is247Services?.toString()}
                                name="is247Services"
                                checked={formik.values.is247Services}
                                // value={true}
                                onChange={(e) => handleIs247ServiceChange(e)}
                                color="secondary"
                                style={{ marginRight: 4 }}
                              />
                            }
                            label={
                              <FormLabel style={{ fontWeight: "bold" }}>
                                24/7 Services
                              </FormLabel>
                            }
                            style={{ marginRight: 20 }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    {/* <Grid sm={12}>
                    <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            paddingTop: "10px",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="is247Services"
                                checked={formik.values.is247Services}
                                value={true}
                                onChange={(e) => handleIs247ServiceChange(e)}
                                color="secondary"
                                style={{ marginRight: 4 }}
                              />
                            }
                            label={
                              <FormLabel style={{ fontWeight: "bold" }}>
                                24/7 Services
                              </FormLabel>
                            }
                            style={{ marginRight: 20 }}
                          />
                        </div>
                    </Grid> */}

                    <Grid
                      container
                      spacing={2}
                      sx={{
                        margin: "2px",
                        borderBottom: "1px solid #D3E0E5",
                        paddingBottom: "36px",
                      }}
                    >
                      <Grid item xs={12} lg={12} my={2}>
                        <Typography fontSize="14px" fontWeight="semiBold">
                          Knowledge Base
                        </Typography>
                      </Grid>
                        <Grid item xs={12} lg={12}>
                          {knowledgeBaseData && (
                          <Grid container spacing={2}>
                            {Object.entries(knowledgeBaseData).map(([key, item]) => (
                              <Grid item xs={12} key={key}>
                                <FormLabel sx={{ fontWeight: 600 }}>
                                  {item.question || ""}
                                </FormLabel>

                                {ARRAY_FIELDS.includes(key) ? (
                                  <>
                                    {(item.answer || []).map((row, index) => (
                                      <Grid
                                        container
                                        spacing={2}
                                        key={index}
                                        sx={{ mb: 1 }}
                                      >
                                        {key === "teamMembers" && (
                                          <>
                                            <Grid item xs={6}>
                                              <SuiInput
                                                placeholder="Name"
                                                value={row.name}
                                                onChange={(e) =>
                                                  handleKBArrayChange(
                                                    key,
                                                    index,
                                                    "name",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SuiInput
                                                placeholder="Role"
                                                value={row.role}
                                                onChange={(e) =>
                                                  handleKBArrayChange(
                                                    key,
                                                    index,
                                                    "role",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Grid>
                                          </>
                                        )}

                                        {key === "faqs" && (
                                          <>
                                            <Grid item xs={6}>
                                              <SuiInput
                                                placeholder="Question"
                                                value={row.question || ""}
                                                onChange={(e) =>
                                                  handleKBArrayChange(
                                                    key,
                                                    index,
                                                    "question",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SuiInput
                                                placeholder="Answer"
                                                value={row.answer || ""}
                                                onChange={(e) =>
                                                  handleKBArrayChange(
                                                    key,
                                                    index,
                                                    "answer",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Grid>
                                          </>
                                        )}
                                      </Grid>
                                    ))}

                                    <SuiButton
                                      size="small"
                                      variant="outlined"
                                      buttonColor="info"
                                      onClick={() => addKBArrayItem(key)}
                                      sx={{ whiteSpace: "nowrap", height: "40px", marginTop: "10px" }}
                                    >
                                      + Add
                                    </SuiButton>
                                  </>
                                ) : (
                                  <SuiInput
                                    multiline
                                    rows={3}
                                    placeholder={item.question}
                                    value={item.answer || ""}
                                    onChange={(e) =>
                                      setKnowledgeBaseData(prev => ({
                                        ...prev,
                                        [key]: {
                                          ...prev[key],
                                          answer: e.target.value,
                                        },
                                      }))
                                    }
                                  />
                                )}
                              </Grid>
                            ))}
                          </Grid>
                        )}
                        </Grid>
                      <Grid item xs={12} lg={6}>
                        <FileUploadUI
                          name="knowledgebaseFiles"
                          id="knowledgebaseFiles"
                          label="Upload Document"
                          fileValue={formik.values.knowledgebaseFiles}
                          accept=".pdf"
                          getFile={handleFileChange}
                          removeFileName={removeFileName}
                        />
                        {/* )} */}
                        <ErrorMessageComponent
                          touched={formik.touched.knowledgebaseFiles}
                          error={formik.errors.knowledgebaseFiles}
                        />
                      </Grid>
                      <Grid item xs={12} lg={10}>
                          <SuiTypography textColor="text2" fontSize={13} pt={1}>
                            *Upload a documents with company details including
                            pricing, policies success stories , case studies and
                            FAQ's.
                            <br />
                            *.PDF with maximum 5MB size are supported.
                          </SuiTypography>
                        </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        my={2}
                        pt={2}
                        sx={{
                          borderTop: "4px solid #E4E9F0",
                          borderBottom: "4px solid #E4E9F0",
                          padding: "27px 0 14px 0",
                        }}
                      >
                        <Typography fontSize="14px" fontWeight="semiBold">
                          <span style={{ color: "red" }}>*</span> Do you also
                          need the full chat transcript in email ?
                        </Typography>
                        <Grid item xs={12} lg={12}>
                          <SuiRadioGroup
                            name="isChatTranscript"
                            valueKey="value"
                            labelKey="label"
                            row
                            options={[
                              { value: true, label: "Yes" },
                              { value: false, label: "No" },
                            ]}
                            value={formik.values.isChatTranscript}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <ErrorMessageComponent
                            touched={formik.touched.businessType}
                            error={formik.errors.businessType}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} lg={12} my={2}>
                        {/* <CustomEndPoints
                          customEndpoints={customEndpoints}
                          setCustomEndpoints={setCustomEndpoints}
                        /> */}
                        <CustomEndpointsV2 ref={customEndpointRef} customEndpoints={customEndpoints} setCustomEnpoints={setCustomEndpoints}/>
                      </Grid>
                    </Grid>
                  </>
                )}

                {step === "second" && (
                  <Grid item xs={12} lg={12}>
                    <RowOrderingGrid
                      templateData={templateData}
                      referencePara={referencePara}
                      mainLeadCollectionHandler={mainLeadCollectionHandler}
                      leadCollectionData={leadCollectionData}
                      updateLeadCollectionData={updateLeadCollectionData}
                      updateLeadCollectionDataOnDragandDrop={
                        updateLeadCollectionDataOnDragandDrop
                      }
                      formik={formik}
                      planType={planType}
                      answersData={answerArray}
                      loginType={type}
                      hyperLinkData={setHyperLinkdata}
                      data={hyperLinkdata}
                      setLeadFormData={setLeadFormData}
                      leadFormData={leadFormData}
                      setLeadCollectionData={setLeadCollectionData}
                    />
                  </Grid>
                )}

                {/* {planType?.includes('xcally') && (
                  <>
                    <Grid item xs={12} lg={6}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="xcally"
                              value={formik.values.xcally}
                              checked={formik.values.xcally}
                              onChange={(e) => formik.setFieldValue('xcally', e.target.checked)}
                              color="secondary"
                              style={{ padding: 0 }}
                            />
                          }
                        />
                        <FormLabel htmlFor="xcally" sx={{ fontWeight: 600 }}>
                          Xcally
                        </FormLabel>
                      </div>
                      <ErrorMessageComponent
                        touched={formik.touched.xcally}
                        error={formik.errors.xcally}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}></Grid>
                    <Grid item xs={12} lg={4}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <SuiInput
                          size="large"
                          inputSettungs={{ autoComplete: "off", required: true }}
                          type="text"
                          placeholder="Enter Variant Key"
                          id="variantKey"
                          name="variantKey"
                          value={formik.values.variantKey}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <ErrorMessageComponent
                          touched={formik.touched.variantKey}
                          error={formik.errors.variantKey}
                        />
                      </div>
                    </Grid>
                  </>
                )} */}
              </Grid>

              <Grid item xs={12}>
                <Grid container pb={2} pt={4} columnSpacing={2} rowSpacing={1}>
                  <Grid item>
                    <SuiButton
                      size="small"
                      onClick={onClickCancel}
                      variant="outlined"
                      buttonColor="dark"
                      sx={{ px: "1rem", py: "0.4rem" }}
                    >
                      Cancel
                    </SuiButton>
                  </Grid>
                  <Grid item>
                    <SuiButton
                      type="submit"
                      size="small"
                      buttonColor="info"
                      sx={{ px: "1rem" }}
                      onClick={formik.handleSubmit}
                    >
                      {id ? (
                        updateLoader ? (
                          <CircularProgress size="20px" color="inherit" />
                        ) : (
                          "Update"
                        )
                      ) : createLoader ? (
                        <CircularProgress size="20px" color="inherit" />
                      ) : (
                        "Create"
                      )}
                    </SuiButton>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </WrapCard>
      )}
    </div>
  );
};

export default CreateTenant;
